module.exports = __webpack_public_path__ + "img/natural@2x.61c51f7.jpg";